<template>
    <div class="form-group has-add-message col-12 no-gutters"
         :class="{'has-error': errors && errors.has(field)}">
        <label :for="field">{{ label }}</label>
        <Editor v-model="html" :init="config" :disabled="disabled"/>
        <AppError :errors="errors" :field="field" v-if="field && errors"/>
    </div>
</template>

<script>
import 'tinymce/tinymce';
import 'tinymce/themes/silver';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/link';
import 'tinymce/plugins/image';
import 'tinymce/plugins/hr';
import 'tinymce/plugins/code';
import 'tinymce/plugins/table';
import 'tinymce/plugins/paste';
import Editor from '@tinymce/tinymce-vue';
import AppError from './AppError';
import MediaService from '../../services/media.service';

export default {
  props: ['errors', 'label', 'value', 'field', 'disabled'],
  components: {
    AppError,
    Editor,
  },
  data() {
    return {
      config: {
        plugins: [
          'advlist link image lists hr code table paste',
        ],
        contextmenu: false,
        toolbar: 'styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image | forecolor backcolor',
        file_picker_types: 'image',
        relative_urls: false,
        remove_script_host: false,
        convert_urls: true,
        content_style: 'img { max-width: 100%; height: auto; }',
        file_picker_callback: (cb) => {
          const input = document.createElement('input');
          input.setAttribute('type', 'file');
          input.setAttribute('accept', 'image/*');

          input.onchange = () => MediaService.upload({
            file: input.files[0],
            type: 'wysiwyg',
          })
            .then((res) => cb(res.media.url))
            .finally(() => input.remove());

          input.click();
        },

      },
    };
  },
  computed: {
    html: {
      set(val) {
        this.$emit('input', val);
      },
      get() {
        return this.value;
      },
    },
  },
};
</script>
<style lang="css">
    @import "~tinymce/skins/ui/oxide/skin.css";
</style>
